<template>
	<LayoutOffcanvasStandard ref="offcanvas" id="customer-modal-contact" :title="customer?.name" subtitle="Medios de contacto registrados" bodyClass="container-md vstack gap-5">
		<template #body>
			<div class="vstack gap-5">
				<ul class="list-group list-group-flush rounded-4">
					<CustomerCommonContactPhone v-for="(value, index) in (customer?.contacts?.phones ?? [])" v-bind:key="index" :value="String(value)" :country_code="customer?.company?.country_code" @select="contacted" />
					<CustomerCommonContactEmail v-for="(value, index) in (customer?.contacts?.emails ?? [])" v-bind:key="index" :value="String(value)" @select="contacted" />
					<li class="list-group-item px-0 py-3 lh-sm" v-if="(customer?.contacts?.emails ?? []).length == 0 && (customer?.contacts?.phones ?? []).length == 0">
						No se encontraron datos de contacto.
					</li>
				</ul>
			</div>
		</template>
	</LayoutOffcanvasStandard>
</template>

<script>
	import { ref, onMounted, getCurrentInstance } from 'vue';
	import { Modal, Offcanvas } from 'bootstrap';

	export default {
		setup(props) {
			const instance = getCurrentInstance();
			const offcanvas = ref(null);
			const customer = ref(null);
			const options = ref(null);

			const closeOpenOffcanvas = () => {
				if(document.querySelector('.offcanvas.show')) {
					var offcanvasShowed = Offcanvas.getInstance(document.querySelector('.offcanvas.show'));
					offcanvasShowed.hide();
				}

				if(document.querySelector('.modal.show')) {
					var modalShowed = Modal.getInstance(document.querySelector('.modal.show'));
					modalShowed.hide();
				}
			}

			const contacted = (extras) => {
				if(options.value?.register) {
					offcanvas.value.offcanvas.hide();
					instance.proxy.$customerContacted(customer.value, extras);
				}
			}

			const customerContact = (dataCustomer = null, dataOptions = {}) => {
				closeOpenOffcanvas();
				customer.value = dataCustomer;
				options.value = dataOptions;
				offcanvas.value.offcanvas.show();
			}

			onMounted(() => {
				if(instance) instance.appContext.config.globalProperties.$customerContact = customerContact;
			});

			return { customer, offcanvas, contacted };
		}
	}
</script>